// src/store/masterBriefStore.ts
import { create } from "zustand";
import { useUserStore } from "./userStore";
import { fetchMasterBriefs } from "../apiServices/partsCatalogApi";
import type { MasterBriefDto } from "../models/MasterBrief";

function resolveOem(): string {
  const s: any = useUserStore.getState();
  const legacy = s.currentOEM?.oemName as string | undefined;
  if (legacy && legacy.trim()) return legacy;
  const u = s.user as { oemId?: number } | null;
  console.log({ currentOEM: s.currentOEM?.oemName, userOEM: s.user?.oemId });
  if (u?.oemId) return `Oem${u.oemId}`;
  const envDefault = (import.meta as any)?.env?.VITE_DEFAULT_OEM as string | undefined;
  return envDefault && envDefault.trim() ? envDefault : "Oem1";
}

interface MasterBriefStore {
  briefs: MasterBriefDto[];
  loading: boolean;
  error: string | null;
  hasLoadedOnce: boolean;

  load: () => Promise<void>;
  clear: () => void;
}

export const useMasterBriefStore = create<MasterBriefStore>((set, get) => ({
  briefs: [],
  loading: false,
  error: null,
  hasLoadedOnce: false,

  async load() {
    const { accessToken, user } = useUserStore.getState();
    if (!accessToken) {
      set({ briefs: [], loading: false, error: null, hasLoadedOnce: true });
      return;
    }
    const role = String(user?.role ?? "").toUpperCase();
    const vendorId = role.includes("VENDOR") ? Number(user?.vendorId ?? 0) : 0;
    const oem = resolveOem();

    set({ loading: true, error: null });
    try {
      const data = await fetchMasterBriefs(oem, vendorId);
      set({ briefs: data, loading: false, hasLoadedOnce: true });
    } catch (e: any) {
      set({ briefs: [], loading: false, hasLoadedOnce: true, error: e?.message ?? "Failed to load components" });
    }
  },

  clear: () => set({ briefs: [], loading: false, error: null, hasLoadedOnce: false }),
}));
